import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";



////api call for users listing//////////////
export const updateStatus = createAsyncThunk("usermanagement/statuschange", async (reqbody) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api/updateAvtiveUsers", requestOptions);
    const respdata = await response.json();
    return respdata;

})



const activeInactiveReducer = createSlice({
    name: "activeInactiveReducer",
    initialState: {
        loading: false,
        success: false
    },

    reducers: {
        resetSuccess(state, action) {
            state.success = false;
        }
    },

    extraReducers: {
        [updateStatus.rejected]: (state, action) => {
            state.loading = false;
        },
        [updateStatus.pending]: (state, action) => {
            state.loading = true;
            state.success = false;
        },
        [updateStatus.fulfilled]: (state, action) => {
            state.loading = false;
            if(action.payload.status == 'success'){
                state.success = true
            }
        }

    }
})
export default activeInactiveReducer.reducer
export const { resetSuccess } = activeInactiveReducer.actions;